'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itSortFactory", function (objectUtils, sortUtils) {
  // TODO : registry to add comparators

  var comparators = {
    boolean: sortUtils.booleanComparatorBuilder,
    string: sortUtils.stringComparatorBuilder,
    alphanum: sortUtils.alphanumCompartorBuilder,
    number: sortUtils.numberComparatorBuilder,
    montant: sortUtils.montantComparatorBuilder,
    taux: sortUtils.montantComparatorBuilder,
    date: sortUtils.dateComparatorBuilder
  };
  return {
    /**
     * s'appuie sur column.sortType || column.dataType (ou par défaut string) qui peut etre une fonction de tri ou le nom d'un comparateur
     * @param column qui doit avoir un champs attribute pour construire la methode d'accès (ou un autre champs infiqué par le parametre attribute)
     * @param attribute optionnel, si non renseigné utilise column.attribute
     * @returns un comparator auquel passer en parametre des lignes
     */
    getColumnComparator: function getColumnComparator(column, attribute) {
      var typeOrFunc = column.sortType || column.dataType || "string";
      var sortMethod;
      if (_.isFunction(typeOrFunc)) {
        sortMethod = typeOrFunc;
      } else {
        var comparatorBuilder = comparators[typeOrFunc];
        sortMethod = comparatorBuilder(attribute || column.attribute);
      }
      return sortMethod;
    },
    sort: function sort(dataSource, column, reverse) {
      if (dataSource == null) {
        return;
      }

      // TODO : try to add type autodetect guess dataType using first element data ?

      var typeOrFunc = column.sortType || column.dataType || "string";
      var sortMethod;
      if (_.isFunction(typeOrFunc)) {
        sortMethod = typeOrFunc;
      } else {
        var comparatorBuilder = comparators[typeOrFunc];
        sortMethod = comparatorBuilder(column.attribute);
      }
      try {
        dataSource.sort(sortMethod);
      } catch (err) {
        throw new Error("Impossible de trier la colonne " + JSON.stringify(column) + ", vérifiez que vous avez un attribute non null et sortType correctement défini : " + err.message, err);
      }
      if (reverse) {
        dataSource.reverse();
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itSortFactory.js
// module id = 2804
// module chunks = 13